<nav class="sidebar-nav">
    <ul id="sidebarnav">
		<li class="nav-devider"></li>
        <!-- First level menu -->
        <li class="sidebar-item" [class.active]="showMenu === sidebarnavItem.title" *ngFor="let sidebarnavItem of sidebarnavItems"
            [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
            <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true">{{sidebarnavItem.title}}</div>
            <a class="sidebar-link waves-effect waves-dark" [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.path] : null"
                [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink;" (click)="addExpandClass(sidebarnavItem.title)"
                [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'" style="white-space: normal;">
                <i [ngClass]="[sidebarnavItem.icon]"></i>
                <span class="hide-menu" style="margin-left: 10px;">{{sidebarnavItem.title}}</span>
            </a>
        </li>
    </ul>
</nav>